import { LabelWithLocation, Location } from '@skop-app/lib-domain/types'
import { standardizeString } from '@skop-app/lib-domain/utils'
import { z } from 'zod/v4'

import type { OptionForDisplay } from '@/types/grid'
import type { ProjectLabel, Property } from '@/types'

/** Accepts both OptionLookup and Property for backward compatibility. */
type MatchKeyOptionsByID = Record<
  string,
  { label?: string; value?: unknown; id?: string }
>

/**
 * @deprecated Could be replaced by {@link matchValue} from {@link @/domain/product/persistence/propertyRules.ts}
 */
export const matchKey = (
  value: string,
  references:
    | Property[]
    | LabelWithLocation[]
    | ProjectLabel[]
    | OptionForDisplay[],
  optionsByID?: MatchKeyOptionsByID,
): Partial<Property> & {
  review?: unknown
  location?: Location
  city?: string
} => {
  if (optionsByID?.[value]) {
    return optionsByID[value] as Partial<Property> & {
      review?: unknown
      location?: Location
      city?: string
    }
  }

  const allrefs =
    references?.flatMap((ref) => [
      // Include the parent reference if it has id, label, or value
      ...(ref.id || ref.label || ref.value ? [ref] : []),
      // Include all options
      ...(ref.options || []),
    ]) ?? []
  const normValue = standardizeString(value)
  const result = allrefs.find(
    (ref) =>
      (ref.label && standardizeString(ref.label) === normValue) ||
      (ref.value && standardizeString(ref.value) === normValue) ||
      (ref.id && standardizeString(ref.id) === normValue),
  )
  const deletedRef = !result && z.uuid().safeParse(value).success

  if (deletedRef) return { label: value, value: value, review: true }
  return result ?? { label: value, value: value, review: false }
}
